import React, {useCallback, useEffect, useState} from 'react';
import './App.css';
import {validate} from "@commons/actions/authentication.action";
import {
    resetContratto,
    selectIdAzienda,
    selectIdAziendaMaster,
    selectPersistToken,
    selectStatus,
    selectToken,
    setupAzienda,
    setupAziendaMaster,
    systemExpired,
    systemReady,
    systemWarning
} from "@commons/core.slice";
import {useAppDispatch, useAppSelector} from "@hooks/redux-hooks/hooks";
import 'react-toastify/dist/ReactToastify.css';
import {setupMenu} from "@coreMenu/slice";
import {useGetAziendaQuery} from "@commons/features/azienda/api";
import moment from "moment";
import {AppStatus} from "@commons/core.state";
import {toastAsError} from "@utilities/toastAsError";
import {useLavoratore} from "@commons/hooks/useLavoratoreHR";

export interface AppHRProps {
    isBoot: boolean,
    isRunning: boolean,
    isTrust: boolean,
    minutiDiInattivita: number,
    appState: AppStatus,
}

const App: React.FC<{ auxToken: string | undefined, AppXXX: React.FC<AppHRProps> }> = ({auxToken, AppXXX}) => {
    const dispatch = useAppDispatch();
    const appState = useAppSelector(selectStatus);
    const currentTokenRecord = useAppSelector(selectToken);
    const previousToken = useAppSelector(selectPersistToken);
    const token = auxToken || previousToken;
    //const persistContratto = useAppSelector(selectPersistContratto);
    const isBoot = appState === 'BOOT';
    const isRunning = appState === 'RUN' || appState === 'ISEXPIRING' || appState === 'EXPIRED';
    //const isTrust = useAppSelector(selectIsLogged) ? true : false;
    const isTrust = isRunning;
    const [minuti, setMinuti] = useState<number>(0);
    // BOOTSTART!
    useEffect(() => {
        if (appState === 'BOOT') {
            if (token) {
                /*
                    const idAziendaMaster: number = Number(getItemFromLocalStorage('idAziendaMaster'));
                    const idAzienda: number = Number(getItemFromLocalStorage('idAzienda'));
                    const idDip: number = Number(getItemFromLocalStorage('idDip'));
                */
                //const {idAziendaMaster, idAzienda, id} = persistContratto;
                //dispatch(validate({token, idAziendaMaster, idAzienda, idDip: id}));
                dispatch(validate({token}));
            } else {
                dispatch(systemReady());
            }

            // Implemento menu
            const json = require(process.env.NODE_ENV === 'development' ? './data/menu_dev.json' : './data/menu.json');
            dispatch(setupMenu(json));
        }
        //}, [appState, persistContratto, dispatch, token]);
    }, [appState, dispatch, token]);

    const tokenExpires = (currentTokenRecord && currentTokenRecord.token) ? currentTokenRecord.tokenExpires : null;
    //const tokenMaxAge = (currentTokenRecord && currentTokenRecord.token) ? currentTokenRecord.tokenMaxAge : null;

    const watchdog = useCallback(() => {
        const minWarning = 5 * 60;//(29 * 60) + 40; // dopo 25 minuti di inattività
        const minExpires = 0 * 60;//(29 * 60) + 20; // dopo 30 minuti di inattività
        if (tokenExpires) {
            const expires = moment(tokenExpires, 'YYYY-MM-DDTHH:mm:ss');
            const diff = expires.diff(moment(), 'seconds');
            if (diff <= minExpires) {//0
                dispatch(systemExpired());
            } else if (diff <= minWarning) {//5
                dispatch(systemWarning());
            }

            //setMinuti(expires.diff(moment(), 'seconds'));
            setMinuti(diff);
        }
        //console.log('click!', tokenExpires, tokenMaxAge)
    }, [dispatch, tokenExpires]);

    useEffect(() => {
        const timer = setInterval(watchdog, 30000);
        return () => clearInterval(timer);
    }, [watchdog]);


    // Fisso il prima possibile
    const contrattoCorrente = useLavoratore(toastAsError);

    // aggiorno azienda master
    const idAziendaMaster = useAppSelector(selectIdAziendaMaster);
    const aziendaMasterQuery = useGetAziendaQuery({idAzienda: idAziendaMaster!}, {skip: !idAziendaMaster});
    useEffect(() => {
        if (aziendaMasterQuery.data) {
            dispatch(setupAziendaMaster(aziendaMasterQuery.data));
        }
    }, [dispatch, aziendaMasterQuery.data])

    // aggiorno azienda ed eventualmente il lavoratore/contratto corrente!
    const idAzienda = useAppSelector(selectIdAzienda);
    const aziendaQuery = useGetAziendaQuery({idAzienda: idAzienda!}, {skip: !idAzienda});
    useEffect(() => {
        if (aziendaQuery.data) {
            dispatch(setupAzienda(aziendaQuery.data));
            if (!contrattoCorrente || contrattoCorrente.idAzienda !== aziendaQuery.data.idAzienda) {
                /*  N.B. Evito di resettare il contratto se il contratto corrente fa riferimento alla stessa azienda appena selezionata!
                    Tale controllo permette di preservare il lavoratore/contratto dolo aver ricaricato la pagina (F5)!
                 */
                dispatch(resetContratto());
            }

            if (window.parent)
                window.parent.postMessage({idAziendaMaster: aziendaQuery.data.idAziendaMaster, idAzienda: aziendaQuery.data.idAzienda}, "*");

        }
    }, [dispatch, aziendaQuery.data, contrattoCorrente]);

    return <AppXXX isBoot={isBoot} isRunning={isRunning} isTrust={isTrust} minutiDiInattivita={minuti} appState={appState}/>
}

export default App;
